const initialState = {
	sectors: []
};

export default (state = initialState, action) => {
	switch (action.type) {
		case "SECTORS_ARE_LOADING":
			return {
				...state,
				isLoading: 1
			};
		case "SECTORS_HAS_ERROR":
			return {
				...state,
				isLoading: 0,
				error: action.error
			};
		case "SECTORS_SUCCESS":
			return {
				...state,
				sectors: action.data.sectors,
				isLoading: 0
			};

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/store/reducers/sectors.js